{
    "MaxfilterlistlimitLabel": "Maximale Begrenzung der Filterliste:",
    "MaxreportrowdisplimitLabel": "Maximale Anzeigegrenze für Berichtszeilen:",
    "MaxfilterlistlimitPlaceholder": "150",
    "MaxreportrowdisplimitPlaceholder": "150",
    "ContentRestriction_SectionHeader": "Inhaltsbeschränkung",
    "ContentRestriction_SectionPara": "Für Umgebungen mit einer großen Anzahl von Geräten und\/oder Agenten können Sie die maximale Anzahl von ",
    "NAME": "ContentRestriction"
}